import classnames from 'classnames';
import { InformationCircleOutlineIcon } from 'assets/svgs';
import { Text } from 'components';

interface Props {
  label: string;
  htmlFor?: string;
  labelTooltip?: string;
  className?: string;
  color?: 'primary' | 'secondary' | 'tertiary' | 'description' | 'white' | 'black';
  weight?: 'semibold' | 'medium' | 'regular';
  size?: 'heading1' | 'heading2' | 'heading3' | 'body1' | 'body2' | 'small' | 'medium' | 'header';
}

const Label = ({ label, htmlFor, labelTooltip, className, color, weight, size }: Props) => {
  return (
    <label htmlFor={htmlFor} className={classnames('mb-1 flex flex-row items-center gap-1', className)}>
      <Text size={size ?? 'body2'} weight={weight ?? 'regular'} color={color ?? 'secondary'}>
        {label}
      </Text>
      {labelTooltip && (
        <div className="group relative">
          <InformationCircleOutlineIcon className="[&_path]:stroke-text-secondary" />
          <Text
            className={
              'invisible absolute left-5 top-0 z-10 w-fit whitespace-nowrap rounded border border-border-primary bg-bg-layer3 p-2  group-hover:visible'
            }
            weight="regular"
            size="small"
          >
            {labelTooltip}
          </Text>
        </div>
      )}
    </label>
  );
};

export default Label;
